<div class="container-fluid padding-top padding-bottom">
  <div class="row">
    <div class="col-xs-12">
      <button class="btn btn-primary"
              (click)="goBack()">Go Back</button>
      <span *ngIf="updated; else updating"
            style="float:right">
        <span class="dot"></span> Automatically Saved
      </span>
    </div>
    <div class="col-xs-12 text-center">
      <h1>
        <span *ngIf="!editName; else editNameBox">{{ pageData?.name }}
          <sup>
            <em (click)="editName = true"
                class="icon-pencil lead-hot"></em>
          </sup>
        </span>&nbsp;
        <button class="btn btn-primary"
                (click)="togglePreviewPage()"
                style="float:right">{{previewButtonText}}</button>
        <button class="btn btn-warn"
                (click)="duplicatePage()"
                style="float:right">Duplicate Page</button>
      </h1>
    </div>
    <div [hidden]="showPreview"
         class="col-xs-12 text-center">
      URL(s):
      <div class="lt-grey"
           [innerHTML]="printPageUrls()"></div>
    </div>
  </div>

  <div class="row">
    <div class="col-xs-12 text-center">
      <button class="btn btn-secondary"
              (click)="updateSettingsOnServer()">Update Settings on Server</button>
    </div>
  </div>

  <div [hidden]="!showPreview"
       class="row">
    <div class="col-sm-12 sm-padding-top left-col">
      <div id="froalaPreview"
           [froalaView]="pageData.html"></div>
    </div>
  </div>
  <div [hidden]="showPreview"
       class="row">
    <div class="col-sm-8 sm-padding-top left-col">
      <div *ngIf="!pageData.isRows; else rows"
           id="froalaEditor"
           [froalaEditor]="options"
           [(froalaModel)]="pageData.html"></div>
      <ng-template #rows>
        <div *ngFor="let row of pageData.rows; let i = index; let last = last; let first = first"
             [ngStyle]="{'border-bottom': last ? 'none' : '1px solid rgba(0,0,0,0.33)'}"
             class="col-xs-12 about-row">
          <div class="row">
            <div class="col-xs-12">
              <label for="row-title-{{i}}">Row Title</label>
              <input class="full-width"
                     pInputText
                     id="row-title-{{i}}"
                     [(ngModel)]="pageData.rows[i].title"
                     (change)="savePage()" />
            </div>
            <div class="col-xs-12">
              <label for="row-image-{{i}}">Row Image/Video Poster URL</label>
              <input class="full-width"
                     pInputText
                     id="row-image-{{i}}"
                     [(ngModel)]="pageData.rows[i].imageUrl"
                     (change)="savePage()" />
            </div>
            <div class="col-xs-12">
              <label for="row-image-alt-{{i}}">Row Image Alt (leave blank to use image file name)</label>
              <input class="full-width"
                     pInputText
                     id="row-image-alt-{{i}}"
                     [(ngModel)]="pageData.rows[i].imageAltText"
                     (change)="savePage()" />
            </div>
            <div class="col-xs-12">
              <label for="row-video-{{i}}">Row Video URL (leave blank if image only)</label>
              <input class="full-width"
                     pInputText
                     id="row-video-{{i}}"
                     [(ngModel)]="pageData.rows[i].videoUrl"
                     (change)="savePage()" />
            </div>
            <div class="col-xs-12">
              <p>
                <input type="checkbox"
                       name="borderRadius"
                       [(ngModel)]="pageData.rows[i].borderRadius"
                       (change)="savePage()"> Border Radius
              </p>
            </div>
            <div class="col-xs-12">
              <label for="row-layout-{{i}}">Row Layout</label>
              <select class="form-control"
                      id="row-layout-{{i}}"
                      name="row-layout-{{i}}-select"
                      (change)="savePage()"
                      [(ngModel)]="pageData.rows[i].layout">
                <option></option>
                <option *ngFor="let layout of rowLayoutOptions"
                        [value]="layout.value">{{layout.label}}</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <p>HTML</p>
              <textarea [froalaEditor]="options"
                        [(froalaModel)]="pageData.rows[i].html"
                        class="full-width"></textarea>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 text-center">
              <button *ngIf="!first"
                      type="button"
                      class="btn btn-secondary m-2"
                      (click)="moveRow('up', i)">
                <i class="fa fa-arrow-up"></i> Move
              </button>
              <button *ngIf="!last"
                      type="button"
                      class="btn btn-secondary m-2"
                      (click)="moveRow('down', i)">
                <i class="fa fa-arrow-down"></i> Move
              </button>
              <button type="button"
                      class="btn btn-danger m-2"
                      (click)="removeRow(i)">
                Remove Row
              </button>
            </div>
          </div>
        </div>
        <div class="col-xs-12 text-center">
          <button type="button"
                  class="btn btn-accent btn-lg m-5"
                  (click)="addRow()">
            Add Row
          </button>
        </div>
      </ng-template>
    </div>
    <div class="col-sm-4 sm-padding-top right-col">
      <div class="row">
        <div class="col-xs-12">
          <div class="checkbox">
            <label>
              <input type="checkbox"
                     name="isRows"
                     [(ngModel)]="pageData.isRows"
                     (change)="savePage()"> Use rows instead of blank slate
            </label>
          </div>
        </div>
      </div>
      <div *ngIf="pageData.isRows"
           class="row">
        <div class="col-xs-12">
          <div class="checkbox">
            <label>
              <input type="checkbox"
                     name="hideTitle"
                     [(ngModel)]="pageData.hideTitle"
                     (change)="savePage()"> Hide Title at Top
            </label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="checkbox">
            <label>
              <input type="checkbox"
                     name="showHero"
                     [(ngModel)]="pageData.showHero"
                     (change)="savePage()"> Show hero to match non-custom pages
            </label>
          </div>
        </div>

      </div>
      <div *ngIf="pageData.showHero"
           class="col-xs-12">
        <div class="col-xs-12">
          <label for="title">New Title</label>
          <input class="full-width"
                 pInputText
                 id="title"
                 [(ngModel)]="pageData.title"
                 (change)="savePage()" />
        </div>
        <div class="col-xs-12">
          <label for="metaTitle">Hero Background</label>
          <input class="form-control"
                 id="heroBackground"
                 name="heroBackground"
                 [(ngModel)]="pageData.background"
                 (change)="savePage()">
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="checkbox">
            <label>
              <input type="checkbox"
                     name="isLandingPage"
                     [(ngModel)]="pageData.isLandingPage"
                     (change)="addOrRemoveLandingPageFromDropdown()"> Landing Page (Doesn't show up in site navigation)
            </label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="checkbox">
            <label>
              <input type="checkbox"
                     name="isLocationSpecific"
                     [(ngModel)]="pageData.isLocationSpecific"
                     (change)="savePage()"> Location Specific
            </label>
          </div>
        </div>
      </div>
      <div *ngIf="pageData.isLocationSpecific"
           class="row">
        <div class="col-xs-12 lt-grey">
          <strong>Select Locations</strong>
          <div *ngFor="let location of locations"
               class="checkbox">
            <label>
              <input type="checkbox"
                     name="{{location.name}}"
                     [value]="location"
                     [checked]="getCheckboxValue(location.key)"
                     (change)="toggleLocation(location.key)"> {{location.name}}
            </label>
          </div>
        </div>
      </div>
      <div *ngIf="!pageData.isLandingPage"
           class="row sm-padding-top">
        <div class="col-xs-12">
          <label for="dropdown">Navbar dropdown to put page in</label>
          <select class="form-control"
                  id="dropdown"
                  name="dropdown"
                  (change)="changeDropdown($event)"
                  [(ngModel)]="pageData.dropdownKey">
            <option></option>
            <option *ngFor="let dropdown of dropdowns"
                    [value]="dropdown.key">{{dropdown.name}}</option>
          </select>
        </div>
      </div>
      <div *ngIf="pageData?.dropdownKey && !pageData.isLandingPage"
           class="row sm-padding-top">
        <div class="col-xs-12">
          <label>Drag to re-order dropdown links</label>
          <div [dragula]="'dropdown-bag'"
               [dragulaModel]="clientData?.navigation[pageData?.dropdownKey].children"
               class="sortable-wrapper">
            <div *ngFor="let child of clientData?.navigation[pageData?.dropdownKey].children"
                 class="sortable-item">{{child?.name}}</div>
          </div>
        </div>
      </div>
      <div class="row sm-padding-top">
        <div *ngIf="pageData.isLandingPage"
             class="col-xs-12">
          <label for="navbarContent">Navbar Content (HTML allowed)</label>
          <input class="form-control"
                 id="navbarContent"
                 name="navbarContent"
                 [(ngModel)]="pageData.navbarContent"
                 (change)="savePage()">
        </div>
        <div class="col-xs-12">
          <label for="metaTitle">Meta Title</label>
          <input class="form-control"
                 id="metaTitle"
                 name="metaTitle"
                 [(ngModel)]="pageData.metaTitle"
                 (change)="savePage()">
        </div>
        <div class="col-xs-12 sm-padding-top">
          <label for="metaImage">Meta Image</label>
          <input class="form-control"
                 id="metaImage"
                 name="metaImage"
                 [(ngModel)]="pageData.metaImage"
                 (change)="savePage()">
        </div>
        <div class="col-xs-12 sm-padding-top">
          <label for="metaImageAlt">Meta Image Alt Text</label>
          <input class="form-control"
                 id="metaImageAlt"
                 name="metaImageAlt"
                 [(ngModel)]="pageData.metaImageAlt"
                 (change)="savePage()">
        </div>
        <div class="col-xs-12 sm-padding-top">
          <label for="metaDescription">Meta Description</label>
          <textarea class="form-control"
                    id="metaDescription"
                    name="metaDescription"
                    [(ngModel)]="pageData.metaDescription"
                    (change)="savePage()">
          </textarea>
        </div>
      </div>
    </div>
  </div>
</div>
<button id="hacky-save-button-because-froala"
        (click)="savePage()"></button>
<ng-template #editNameBox>
  <span>
    <input pInputText
           name="pageDataName"
           [(ngModel)]="pageData.name">
    <em (click)="editName = false; savePage()"
        class="icon-check lead-hot"></em>
  </span>
</ng-template>
<ng-template #updating>
  <span style="float:right">
    <i class='fa fa-spinner fa-spin'></i> Updating Changes...
  </span>
</ng-template>



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/edit-custom-page/edit-custom-page.component.html